module.exports = __webpack_public_path__ + "static/img/home_header_logo_taopin.3b4d4c5c.png";